import { connect } from 'react-redux';
import FreeStreamingModal from '../components/freeStreamingModalComponent';
import { sendMessage } from '../actions/freeStreamingAction';

const mapStateToProps = (state) => ({
    submitting: state.freeStreaming.submitting,
    submitted: state.freeStreaming.submitted,
});
const mapDispatchToProps = (dispatch) => ({
    sendMessage: (data) => {
        dispatch(sendMessage(data));
    },
});
const FreeStreamingContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(FreeStreamingModal);

export default FreeStreamingContainer;
